import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useHistory } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { useAuth } from "authentication";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

const Download = () => {
  const history = useHistory()
  const { authUser } = useAuth();  // 取公司级配置
  let { params } = useParams();  // 获取路径参数
  let url = params + history.location.search;
  let errorMessageText = 'Error!';

  useEffect(() => {
    // 等 authUser 加载完成再处理：需要读取公司开关 DisableChromePdfViewer 决定查看器模式
    if (!authUser) return;
    let urlParams = new URLSearchParams(history.location.search);
    let filename = urlParams.get('filename');
    document.title = filename;
    // 公司级开关：为 true 时禁用浏览器原生 PDF 查看器，改用内置 pdf.js（可控下载文件名）；否则保持原样
    const usePdfJs = authUser?.Company?.DisableChromePdfViewer === true;

    httpClient({
      method: 'get',
      url: url,
      responseType: 'blob'
    })
      .then(({ data }) => {
        if (data != null) {
          if (data.type === 'text/plain') {
            let blobUrl = URL.createObjectURL(data);
            let iframeElement = document.getElementById("myIframe");
            iframeElement.src = blobUrl;
          } else {
            let blobUrl = URL.createObjectURL(data);
            let iframeElement = document.getElementById("myIframe");
            const extension = filename.slice(filename.lastIndexOf('.')).toLowerCase();
            // 浏览器通常无法显示 HEIC/HEIF；与 ZIP 等普通文件一致，直接保存原文件。
            if (extension === '.heic' || extension === '.heif') {
              globalFunction.saveFile(blobUrl, filename);
              return;
            }
            if (globalFunction.isMobile()) {
              if (globalFunction.isIOS()) {
                globalFunction.saveFile(blobUrl, filename);
              } else {
                switch (extension) {
                  case '.pdf':
                    // 开关开启：走内置 pdf.js 查看器并嵌入文件名（下载按钮可正确命名）；否则保持原样
                    iframeElement.src = usePdfJs
                      ? globalFunction.getPdfViewerUrl(blobUrl, filename)
                      : '/assets/pdfjs/web/viewer.html?file=' + blobUrl;
                    break;
                  case '.jpeg':
                  case '.jpg':
                  case '.png':
                    iframeElement.src = blobUrl;
                    break;
                  default:
                    globalFunction.saveFile(blobUrl, filename);
                    break;
                }
              }
            } else {
              // 桌面端：开关开启且为 PDF 时走内置 pdf.js 查看器（可控下载文件名），否则保持浏览器原生显示
              if (usePdfJs && extension === '.pdf') {
                iframeElement.src = globalFunction.getPdfViewerUrl(blobUrl, filename);
              } else {
                iframeElement.src = blobUrl;
              }
            }
          }
        } else {
          history.push('/error?type=UI&message=No File Data: ' + filename);
        }
      })
      .catch(function (error) {
      });

  }, [url, history, authUser]);

  return (
    <iframe id="myIframe" style={{ width: '100%', height: 'calc(100vh - 6px)' }} />
  );
};

export default Download;
